import styled from "styled-components";
import { MOBILE } from "../../constants/breakpoints";

interface IContainerProps {
    gap?: string
}
export const Container = styled.section<IContainerProps>`
    display: flex;
    margin-top: 40px;
    border: 1px solid #ccc4b3;
    border-radius: 12px;
    padding: 32px;
    flex-direction: column;
    gap: ${(props: IContainerProps) => props.gap ?? '0'};
    .backButton{
        &:hover {
            cursor: pointer;
            transform: scale(1.1);
            transition: all 0.1s ease-in-out;
        }
    }
    .backIcon{
        transform: rotate(90deg)
    }
    .descText{
        font-size: 20px;
    }
    .titleText{
        width: 100%;
    }
    @media (max-width: ${MOBILE}px) {
        width: 100%;
        height: max-content;
        padding: 16px 24px;
    }
`